import { useNavigate } from "react-router-dom";
import { useProjectsPage } from "../../api/api-hooks";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTanstackTableUi from "../../common/ReactTanstackTableUi";
// import { FaTrashAlt, FaEye } from "react-icons/fa";
import { formatDateTimeAndYear } from "../../utils/date-utils";
import { usePagination } from "../hooks/usePagination";
import useCommonStore from "../../store/CommonStore";
import { getDateRangeFromSelectedValue } from "../../common/Constants";

function prepareColumns(columnHelper: any, handleActions: any) {
  return [
    columnHelper.accessor((row: any) => row.projectListName, {
      id: "projectListName",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base truncate w-full max-w-xs">
              {original?.activity || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Name</div>,
    }),
    columnHelper.accessor((row: any) => row.createdat, {
      id: "Created At",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {/* {original?.createdAt || "--"} */}
              {original?.createdAt
                ? (() => {
                    const { date, time } = formatDateTimeAndYear(
                      original.createdAt
                    );
                    return `${date} ${time}`;
                  })()
                : "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Created At</div>,
    }),
    columnHelper.accessor((row: any) => row.createdBy, {
      id: "Created By",
      cell: (info: any) => {
        const row = info.row;
        const original = row?.original;

        return (
          <div className=" flex flex-col gap-1">
            <div className="font-semibold text-gray-800 text-base max-w-xs">
              {original?.createdBy || "--"}
            </div>
          </div>
        );
      },
      header: () => <div>Created By</div>,
    }),
    // columnHelper.accessor((row: any) => row.actions, {
    //   id: "Actions",
    //   cell: (info: any) => {
    //     const row = info.row;
    //     const original = row?.original;

    //     return (
    //       <div className="flex items-center space-x-4">
    //         {/* View Icon */}
    //         <FaEye
    //           className="text-blue-500 cursor-pointer"
    //           onClick={() => handleActions("view", original?.id)}
    //           title="View"
    //         />

    //         {/* Delete Icon */}
    //         <FaTrashAlt
    //           className="text-red-500 cursor-pointer"
    //           onClick={() => handleActions("delete", original?.id)}
    //           title="Delete"
    //         />
    //       </div>
    //     );
    //   },
    //   header: () => <div>Actions</div>,
    // }),
  ];
}

function ProjectListTable() {
  // const {
  //   data: projects,
  //   isLoading: isProjectsLoading,
  //   // error: projectsError,
  // } = useProjects();

  const { selectedValue } = useCommonStore();

  const dateRange = getDateRangeFromSelectedValue(selectedValue);

  // const { startDate, endDate } = dateRange!;

  const { pageIndex, pageSize, getPaginationInfo } = usePagination();

  const isAllData = dateRange?.isAllData ?? false;
  const startDate = isAllData ? undefined : dateRange?.startDate ?? "";
  const endDate = isAllData ? undefined : dateRange?.endDate ?? "";
  const {
    data: projects,
    isLoading: isProjectsLoading,
    // error: projectsError,
  } = useProjectsPage(pageIndex + 1, pageSize, startDate, endDate, isAllData);

  const apiData = Array.isArray(projects?.items) ? projects?.items : [];
  const columnHelper = createColumnHelper();

  const columns = prepareColumns(columnHelper, handleActions);

  const paginationInfo = getPaginationInfo(projects);

  const navigate = useNavigate();

  //   const [selectedId, setSelectedId] = useState<string | null>(null);

  //   function handleView(fetchId: string) {}

  //   function handleFetch(fetchType: string, fetchId: string) {
  //     // setType(fetchType);
  //     setSelectedId(fetchId);
  //   }

  function handleActions(fetchType: string, fetchId: string) {
    if (!isProjectsLoading && fetchType === "view") {
      navigate(`/project/${fetchId}`);
    }
    if (!isProjectsLoading && fetchType === "delete") {
      // console.log("delete");
    }
  }

  // if (isProjectsLoading) {
  //   return <Loader />;
  // }

  return (
    <div className="md:p-10 p-3">
      <ReactTanstackTableUi
        // data={apiData}
        // columns={columns}
        // pagination={apiData?.length > 10}
        // noDataMessage="Projects"
        // tableTitle="Projects"
        data={apiData}
        columns={columns}
        // pagination={apiData?.length > 10}
        noDataMessage="Projects"
        tableTitle="Projects"
        disableRowHeight={true}
        pagination={true}
        externalPagination={paginationInfo}
        isLoading={isProjectsLoading}
      />
    </div>
  );
}

function Projects() {
  return (
    <div className=" flex flex-col gap-6 ">
      <div>
        <ProjectListTable />
      </div>
    </div>
  );
}

export default Projects;
